module.exports = __webpack_public_path__ + "static/img/M2-S-80-1.7edc955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module1-2/M2-S-80-1.png
// module id = 554
// module chunks = 0